<template>
  <div>
    <a-card title="日管控">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input
            v-model="searchForm.search"
            placeholder="请输入关键词"
            allowClear
            @pressEnter="search"
          />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button
            type="default"
            icon="download"
            style="margin-right: 8px"
            :disabled="selectedRowKeys.length === 0"
            @click="handleBatchExport"
            >导出 {{ selectedRowKeys.length > 0 ? `(${selectedRowKeys.length})` : '' }}</a-button
          >
          <a-button
            type="primary"
            icon="plus"
            style="margin: 0 8px"
            @click="openFormModal(form)"
            >新增</a-button
          >
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table
          size="small"
          :columns="columns"
          :pagination="pagination"
          :dataSource="items"
          rowKey="id"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            preserveSelectedRowKeys: true,
          }"
          @change="tableChange"
        >
          <div slot="total_item" slot-scope="value">
            <span
              >{{ value && value.not_conform }} /
              {{ value && value.total2 }}</span
            >
          </div>
          <div slot="state" slot-scope="value">
            <span>{{
              value === 1
                ? "新建"
                : value === 2
                ? "进行中"
                : value === 3
                ? "已完成"
                : value === 4
                ? "已审核"
                : "审核不通过"
            }}</span>
          </div>
          <div slot="check_result" slot-scope="value">
            <span>{{
              value === 1
                ? "零报告"
                : value === 2
                ? "风险隐患(待整改)"
                : value === 3
                ? "风险隐患(已整改)"
                : ''
            }}</span>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button
                icon="copy"
                size="small"
                @click="copyRecord(item)"
                >复制</a-button
              >
              <a-button
                icon="eye"
                size="small"
                @click="openViewModal(item)"
                >查看</a-button
              >
              <a-button
                v-if="
                  item.check_result === CheckStatus['RiskHazardsToBeRectified']
                "
                icon="edit"
                size="small"
                @click="openFormModal(item, Links.Rectification)"
                >整改</a-button
              >
              <a-button
                v-else
                icon="edit"
                size="small"
                @click="openFormModal(item, Links.End)"
                >编辑</a-button
              >
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small"
                  >删除</a-button
                >
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    
    <!-- 隐藏的批量导出容器 -->
    <!-- 移除 opacity: 0，使用位置偏移隐藏，确保 html2canvas 能抓取到可见内容 -->
    <div style="position: fixed; left: -10000px; top: 0; z-index: -9999;">
      <div 
        id="batchExportContainer" 
        style="width: 800px; padding: 30px; background: white;"
      >
        <div v-if="currentExportItem" class="daily-control-print">
          <PrintDetailList
            :task="currentExportItem"
            :check_list="currentExportItem.check_list || []"
            :template-no="currentExportItem.templateNo || ''"
          />
        </div>
      </div>
    </div>
    
    <!-- <form-modal
            v-model="visible"
            :form="targetItem"
            :clientsClassificationOptions="clientsClassificationItems"
            @create="create"
            @update="update"
    /> -->
    <a-modal
      v-model="importLoading"
      :footer="null"
      :maskClosable="false"
      :closable="false"
    >
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
    <AddForm
      v-if="modelState.show"
      v-bind="modelState"
      :show.sync="modelState.show"
      :link="modelState.link"
      :obj="modelState.obj"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { CheckStatus, Links } from "./data/template.js";
import AddForm from "./component/add-form.vue";
import PrintDetailList from "./component/print-detail-list.vue";
import { dailyControlList, dailyControlDel, dailyControlDetail } from "@/api/control";
import { simpleBatchPdfExport } from '@/utils/batchPdfExport';

export default {
  components: {
    AddForm,
    PrintDetailList,
    // FormModal: () => import("./FormModal.vue"),
  },
  data() {
    return {
      modelState: {
        link: Links.Plan,
        id: "",
        show: false,
        obj: {},

      },
      CheckStatus,
      Links,
      pagination: { current: 1, total: 0, pageSize: 10 },
      searchForm: { search: "", page: 1, page_size: 10, order_by: "id", order_direction: "desc" },
      columns: [],
      loading: false,
      items: [],
      clientsClassificationItems: [],
      visible: false,
      targetItem: { others: {} },
      form: { others: {} },
      importLoading: false,
      selectedRowKeys: [], // 选中的行
      selectedRows: [], // 选中的行数据
      currentExportItem: null, // 当前正在导出的项
      exportColumns: [
        { title: '检查项目', dataIndex: 'itemName', key: 'itemName', width: 200 },
        { title: '检查内容', dataIndex: 'content', key: 'content' },
        { title: '检查状态', dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '问题描述', dataIndex: 'description', key: 'description', width: 150 },
        { title: '整改状态', dataIndex: 'isZG', key: 'isZG', width: 100, scopedSlots: { customRender: 'isZG' } },
        { title: '整改日期', dataIndex: 'changeDate', key: 'changeDate', width: 120 },
      ],
    };
  },
  computed: {},
  methods: {
    getStateText(state) {
      // check_result 状态映射
      const checkResultMap = {
        1: '零报告',
        2: '风险隐患(待整改)',
        3: '风险隐患(已整改)'
      };
      
      // 如果是 check_result 的值,使用检查结果映射
      if (checkResultMap[state]) {
        return checkResultMap[state];
      }
      
      // 否则使用任务状态映射
      const stateMap = {
        1: '新建',
        2: '进行中',
        3: '已完成',
        4: '已审核',
        5: '审核不通过'
      };
      return stateMap[state] || '-';
    },
    getCheckResultStyle(checkResult) {
      // 根据检查结果返回样式
      if (checkResult === 1) {
        return 'color: #52c41a; font-weight: bold;'; // 零报告 - 绿色
      } else if (checkResult === 2) {
        return 'color: #f5222d; font-weight: bold;'; // 待整改 - 红色
      } else if (checkResult === 3) {
        return 'color: #1890ff; font-weight: bold;'; // 已整改 - 蓝色
      }
      return '';
    },
    getNotConformCount(children) {
      // 计算不符合项数量
      if (!children || !Array.isArray(children)) return 0;
      return children.filter(child => child.status === 2).length;
    },
    getPrintTitle(checkResult) {
      // 根据检查结果返回打印标题,模拟单张打印的 title 逻辑
      if (checkResult === 1) {
        return '状态：零报告';
      } else if (checkResult === 2) {
        return '状态：待整改';
      } else if (checkResult === 3) {
        return '状态：整改通过';
      }
      return '';
    },
    hasHighPriorityChild(children) {
      // 检查主项下是否有高优先级子项
      if (!children || !Array.isArray(children)) return false;
      return children.some(child => child.star === 'high');
    },
    getAllConformed(children) {
      // 检查是否所有不符合项都已整改
      if (!children || !Array.isArray(children)) return false;
      const nonConformItems = children.filter(child => child.status === 2);
      if (nonConformItems.length === 0) return false;
      return nonConformItems.every(child => child.isZG);
    },
    handleSuccess() {
      this.list();
    },
    initialize() {
      this.initColumns();
      this.list();
    },
    initColumns() {
      this.columns = [
        {
          title: "任务日期",
          dataIndex: "action_time",
          sorter: true,
          sortOrder: this.searchForm.order_by === "action_time" ? (this.searchForm.order_direction === "asc" ? "ascend" : "descend") : false,
        },
        {
          title: "执行日期",
          dataIndex: "check_time",
          sorter: true,
          sortOrder: this.searchForm.order_by === "check_time" ? (this.searchForm.order_direction === "asc" ? "ascend" : "descend") : false,
        },
        {
          title: "执行人",
          dataIndex: "executor",
        },
        {
          title: "负责人",
          dataIndex: "head",
        },
        {
          title: "完成日期",
          dataIndex: "end_time",
          sorter: true,
          sortOrder: this.searchForm.order_by === "end_time" ? (this.searchForm.order_direction === "asc" ? "ascend" : "descend") : false,
        },
        {
          title: "不符合/总项",
          scopedSlots: { customRender: "total_item" },
        },
        {
          title: "检查状态",
          scopedSlots: { customRender: "state" },
          dataIndex: "state",
        },
        {
          title: "检查结果",
          scopedSlots: { customRender: "check_result" },
          dataIndex: "check_result",
        },
        {
          title: "按时完成",
          dataIndex: "finish",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "210px",
        },
      ];
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    async handleBatchExport() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要导出的记录');
        return;
      }
      
      let currentLoadingMsg = null;
      
      try {
        // 先获取所有选中记录的完整数据
        currentLoadingMsg = this.$message.loading('正在获取选中记录数据...', 0);
        
        const allSelectedData = [];
        for (const id of this.selectedRowKeys) {
          try {
            // 使用详情接口获取完整数据,包括 check_list
            const response = await dailyControlDetail({ id: id });
            if (response.data && response.data.length > 0) {
              const record = response.data[0];
              // console.log(`获取记录 ID ${id} 详情:`, record);
              // console.log(`  - check_list:`, record.check_list);
              // console.log(`  - check_list 长度:`, record.check_list ? record.check_list.length : 0);
              allSelectedData.push(record);
            } else if (response.data) {
              // 如果返回的是单个对象而不是数组
              // console.log(`获取记录 ID ${id} 详情(单个对象):`, response.data);
              // console.log(`  - check_list:`, response.data.check_list);
              allSelectedData.push(response.data);
            }
          } catch (error) {
            console.error(`获取ID ${id} 的数据失败:`, error);
          }
        }
        
        if (currentLoadingMsg) {
          currentLoadingMsg();
        }
        
        if (allSelectedData.length === 0) {
          this.$message.error('未能获取选中记录的数据');
          return;
        }
        
        if (allSelectedData.length < this.selectedRowKeys.length) {
          this.$message.warning(`成功获取 ${allSelectedData.length}/${this.selectedRowKeys.length} 条记录数据`);
        }
        
        await simpleBatchPdfExport(
          allSelectedData,
          'batchExportContainer',
          (item, index) => {
            // 生成文件名
            const date = item.action_time || item.check_time || '';
            const executor = item.executor || '未知';
            const sanitizedDate = date.replace(/[:\s]/g, '-');
            const sanitizedExecutor = executor.replace(/[/\\:*?"<>|]/g, '_');
            return `日管控记录_${sanitizedDate}_${sanitizedExecutor}_${index + 1}`;
          },
          async (item, index) => {
            // 关闭上一个加载提示
            if (currentLoadingMsg) {
              currentLoadingMsg();
            }
            
            // 更新当前导出项
            this.currentExportItem = { ...item };
            
            // 显示新的进度提示
            const progressMsg = `正在处理第 ${index + 1}/${allSelectedData.length} 条记录...`;
            currentLoadingMsg = this.$message.loading(progressMsg, 0);
            
            // 等待Vue更新DOM
            await this.$nextTick();
            
            // 等待DOM渲染完成，增加等待时间确保异步数据加载完成
            await new Promise(resolve => setTimeout(resolve, 1500));
          },
          `日管控批量导出_${new Date().getTime()}.zip`
        );
        
        // 关闭最后一个加载提示
        if (currentLoadingMsg) {
          currentLoadingMsg();
        }
        
        this.$message.success(`批量导出成功！共导出 ${allSelectedData.length} 条记录`);
        
        // 清空选中状态
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.currentExportItem = null;
        
      } catch (error) {
        // 确保关闭加载提示
        if (currentLoadingMsg) {
          currentLoadingMsg();
        }
        this.$message.destroy(); // 清除所有消息
        this.$message.error('批量导出失败：' + error.message);
        console.error('批量导出错误:', error);
      }
    },
    list() {
      this.loading = true;
      dailyControlList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.data;
          // 调试:查看第一条记录的数据结构
          // if (data.data && data.data.length > 0) {
          //   console.log('列表第一条记录数据:', data.data[0]);
          //   console.log('check_list字段:', data.data[0].check_list);
          // }
          // 不清空选中状态,支持跨页选择
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.list();
    },
    update() {
      this.list();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      // 搜索时清空选中状态
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.list();
    },
    openViewModal(item) {
      this.openFormModal(item, Links.End);
    },
    openFormModal(item, link) {
      this.modelState.link = link ? link : Links.Plan;
      this.modelState.id = item.id;
      this.modelState.obj = item;
      this.$set(this.modelState, "obj", item);
      this.modelState.show = true;
      this.$forceUpdate();
      // (this.modelState);
      // this.targetItem = { ...item }
      // this.visible = true;
    },
    copyRecord(item) {
      // 复制记录,移除id和创建时间等字段,保留业务数据
      const copiedItem = { 
        ...item,
        // 复制check_list并清理每个子项的id
        check_list: item.check_list ? item.check_list.map(checkItem => {
          const newCheckItem = { ...checkItem };
          // 清除子项中的id和整改相关字段
          delete newCheckItem.id;
          delete newCheckItem.isZG; // 清除已整改状态
          delete newCheckItem.changeDate; // 清除整改时间
          return newCheckItem;
        }) : []
      };
      
      // 清除不需要复制的字段
      delete copiedItem.id;
      delete copiedItem.create_at;
      delete copiedItem.update_at;
      delete copiedItem.check_time; // 清除执行时间
      delete copiedItem.end_time; // 清除完成时间
      delete copiedItem.state; // 清除状态,让它重新为新建
      delete copiedItem.check_result; // 清除检查结果
      
      // 以计划模式打开(新增)
      this.modelState.link = Links.Plan;
      this.modelState.id = undefined; // 清空id表示新增
      this.modelState.obj = copiedItem;
      this.$set(this.modelState, "obj", copiedItem);
      this.modelState.show = true;
      this.$forceUpdate();
      
      this.$message.success('已复制记录,请修改后保存');
    },
    destroy(id) {
      dailyControlDel({ id: id })
        .then((data) => {
          this.$message.success("删除成功");
          this.list();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      
      // 处理排序逻辑
      if (sorter.field) {
        this.searchForm.order_by = sorter.field;
        this.searchForm.order_direction = sorter.order === "descend" ? "desc" : "asc";
      } else {
        // 没有排序时，恢复默认排序
        this.searchForm.order_by = "create_at";
        this.searchForm.order_direction = "desc";
      }
      
      this.list();
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
/* 打印专用样式 */
.daily-control-print {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

/* 主项分组 - 避免被分页截断 */
.category-section {
  page-break-inside: avoid;
  margin-bottom: 20px;
}

/* 主项样式 - 模拟 DetailItem */
.detail-item {
  width: 100%;
  font-size: 14px;
  line-height: 30px;
  border-bottom: 1px dashed #dcdcdc;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding-left: 20px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 子项样式 - 模拟 DetailInnerItem */
.detail-inner-item {
  margin-left: 2em;
  margin-bottom: 15px;
  padding: 12px;
  border-bottom: 1px dashed #f0f0f0;
  page-break-inside: avoid !important;
  break-inside: avoid !important;
}

/* 检查项行 - 强制避免被分页截断 */
.check-item-row {
  page-break-inside: avoid !important;
  page-break-before: auto;
  page-break-after: auto;
  break-inside: avoid !important; /* 新的CSS标准 */
}

/* 移除表格相关样式,改用列表布局 */

/* 移除表格相关样式,改用列表布局 */

/* 重点项标记保留 */
</style>
